// extracted by mini-css-extract-plugin
export var alt = "Breadcrumb-module--alt--9aa34";
export var breadCrumbCss = "Breadcrumb-module--breadCrumbCss--841f6";
export var desktopOnly = "Breadcrumb-module--desktopOnly--8136d";
export var main = "Breadcrumb-module--main--b4ac1";
export var mobileOnly = "Breadcrumb-module--mobileOnly--b538f";
export var textLeft = "Breadcrumb-module--textLeft--c1af0";
export var underLineText = "Breadcrumb-module--underLineText--e1990";
export var visuallyHidden = "Breadcrumb-module--visuallyHidden--e69e3";